<template>
  <v-dialog v-model="modalVideo" persistent max-width="75%">
    <v-card>
      <v-card-title class="pa-1">
        <v-col cols="12" class="pa-0 text-right"><v-btn icon @click="fechaVideo()" color="primary" ><v-icon>mdi-close</v-icon></v-btn></v-col>
       <v-col cols="12" class="pa-0 text-center"><v-icon class="pr-2" small color=primary>fa-regular fa-life-ring</v-icon><span class="title">Ajuda: {{title}}</span></v-col>
      </v-card-title>
      <v-card-text class="text-center"></v-card-text>
      <div style="padding:50% 0 0 0;position:relative;">
        <iframe :src="'https://player.vimeo.com/video/'+codigo+'?h=d2d997e30a&amp'" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:100%;" 
        :title=title>
        </iframe>
      </div>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script src="https://player.vimeo.com/api/player.js">
</script>
<script>
import { mapState } from "vuex";
export default {
  props: {
    codigo: String,
    title: String,
    modalVideo: Boolean,
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  mounted () {},
  methods: {
    doCallback () {
      if (this.callback) {
        this.callback()
      }
      if (this.messageText) {
        this.messageForm(this.messageText)
        this.messageText = null
        this.$refs.messageTextForm.reset()
      }
      // if (this.callback && !this.textForm.show) {
      //   this.callback()
      //   this.$store.commit('confirmMessage/closeConfirmMessage')
      // }
      // if (this.messageText == null && this.textForm.show) {
      //   this.$refs.messageTextForm.validate()
      // }
      // if (this.messageText != null && this.textForm.show) {
      //   this.messageForm(this.messageText)
      //   this.messageText = null
      //   this.$refs.messageTextForm.reset()
      //   this.$store.commit('confirmMessage/closeConfirmMessage')
      // }
    },
    fechaVideo(){
      let paramModal = {
          codigo: null,
          title: null,
      }
      this.$store.commit('tutorial/fechaVideo', paramModal);
    },
  },
  data () {
    return {
    }
  },
}
</script>

<style>
.confirmMesgTxt {
  border-bottom: 1px solid #eee;
}
</style>
